var projectLocationTypeEnum;
(function (projectLocationTypeEnum) {
    projectLocationTypeEnum["PHYSICAL"] = "physical";
    projectLocationTypeEnum["ONLINE"] = "online";
    projectLocationTypeEnum["AT_HOME"] = "at home";
})(projectLocationTypeEnum || (projectLocationTypeEnum = {}));
export default projectLocationTypeEnum;
